import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/views/layout/Layout";

import warehouseManRouter from "./modules/warehouseManRouter"; // 库房管理

import greenManRouter from "./modules/greenManRouter"; // 平台管理
import recruiting from "./modules/recruiting"; // 招聘管理
import siteManRouter from "./modules/siteManRouter"; // 场地管理
import deviceManRouter from "./modules/deviceManRouter"; // 设别管理
import staffRelationRouter from "./modules/staffRelation"; // 员工关系
import disinfectRouter from "./modules/disinfectRouter"; //  消毒管理


import platformManRouter from "./modules/platformMan"; // 平台管理
import hrManRouter from "./modules/hrMan"; // 人力资源
import processMan from "./modules/processMan"; // 工作流
import adminManRouter from "./modules/adminManRouter"; // 行政管理
import supplyChainRouter from "./modules/supplyChainRouter"; // 供应链
import supplyAssetRouter from "./modules/supplyAssetRouter";
import costManRouter from "./modules/costManRouter"; // 财务管理模块
import jytRouter from "./modules/jytRouter"; // 简E通 模块
import customerCenter from "./modules/customerCenter"; // 客服中心
import qualitySystem from "./modules/qualitySystem"; // 品质系统模块
import qualityControl from "./modules/qualityControl"; // 品质系统模块
import reportMan from "./modules/reportMan"; // 报事管理
import propertyManRouter from "./modules/propertyMan"; // 运营管理
import crmRouter from "./modules/crmRouter"; // crm
import administrationOA from "./modules/administrationOA"; // 行政OA
import examRouter from "./modules/examRouter"; // 考试


// import vehicleManRouter from "./modules/vehicleManRouter"; // 车辆管理
/** note: Submenu only appear when children.length>=1
 *  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    roles: ['admin','editor']    will control the page roles (you can set multiple roles)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if true, the page will no be cached(default is false)
    breadcrumb: false            if false, the item will hidden in breadcrumb(default is true)
  }
**/
export const constantRouterMap = [
  {
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path*",
        component: () => import("@/views/redirect/index")
      }
    ]
  },
  // 页面跳转中继页面
  {
    path: "/white",
    component: () => import("@/views/white/white"),
    hidden: true
  },
  {
    path: "/white-device",
    component: () => import("@/views/white/white-device"),
    hidden: true
  },
  {
    path: "/jytQueueScreen",
    component: () =>
      import("@/views/jyt/medicalRecord/businessHan/jytQueueScreen"),
    hidden: true
  },

  {
    path: "/deviceMan/mbInitiateProcess",
    component: () =>
    import("@/views/deviceMan/dynamicForm/MbInitiateProcess"),
    hidden: true
  },

  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/newServiceMan",
    component: () => import("@/views/jyt/transportMan/newServiceMan"),
    hidden: true
  },

  {
    path: "/crmiInvoicePrint",
    component: () => import("@/components/PrintPage/crmiInvoicePrint"),
    hidden: true
  },
  {
    path: "/recruitingSheetPrint",
    component: () => import("@/views/recruiting/components/recruitingSheetPrint"),
    hidden: true
  },
  {
    path: "/appraisalSheetPrint",
    component: () => import("@/views/recruiting/components/appraisalSheetPrint"),
    hidden: true
  },
  {
    path: "/auth-redirect",
    component: () => import("@/views/login/authredirect"),
    hidden: true
  },
  {
    path: "/404",
    component: () => import("@/views/errorPage/404"),
    hidden: true
  },
  {
    path: "/401",
    component: () => import("@/views/errorPage/401"),
    hidden: true
  },
  {
    path: "/organStructure",
    component: () => import("@/views/hrMan/orgPlan/organStructure"),
    hidden: true
  },
  {
    path: "/printPaper",
    component: () => import("@/views/jyt/drugMail/printPaper"),
    hidden: true
  },
  {
    path: "/printProcess",
    component: () => import("@/views/processMan/printProcess"),
    hidden: true
  },
  {
    path: "/disinfectionStatisticsQueryPrint",
    component: () =>
      import("@/views/disinfectMan/disinfectionStatisticsQuery/disinfectionStatisticsQueryPrint"),
    hidden: true
  },
  // 车辆维保管理-打印
  {
    path: "/vehicleMaintenanceManPrintPaper",
    component: () =>
      import(
        "@/views/adminMan/vehicleMan/maintenanceMan/vehicleMaintenanceMan/printPaper"
      ),
    hidden: true
  },
  // 增减岗单-打印
  {
    path: "/printZjiangangdan",
    component: () =>
      import("@/views/processMan/components/fm/printZjiangangdan"),
    hidden: true
  },

  {
    path: "",
    component: Layout,
    redirect: "dashboard",
    children: [
      {
        path: "dashboard",
        component: () => import("@/views/dashboard/index"),
        name: "万线科技",
        meta: {
          title: "首页",
          icon: "dashboard"
        }
      }
    ]
  },

  {
    path: "/msgMan/:type",
    component: Layout,
    redirect: "",
    children: [
      {
        path: "",
        component: () => import("@/views/msgMan/index"),
        name: "消息中心",
        meta: {
          title: "消息中心",
          icon: "nav-msg"
        }
      }
    ]
  }
];

export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});

export const asyncRouterMap = [
  disinfectRouter,
  deviceManRouter,
  warehouseManRouter,
  staffRelationRouter,
  greenManRouter,
  recruiting,
  siteManRouter,
  examRouter,
  administrationOA, // 行政OA
  platformManRouter, // 平台
  hrManRouter, // hr
  costManRouter, // 财务管理
  supplyChainRouter, // 供应链
  supplyAssetRouter,
  adminManRouter, // 行政管理
  processMan, // 工作流
  propertyManRouter, // 运营管理
  jytRouter, // 简E通
  customerCenter, // 客服中心
  qualitySystem, // 品质系统
  qualityControl,//品质控制
  reportMan, // 报事管理
  crmRouter, // crm

  // vehicleManRouter,  // 车辆管理
  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];
